let PlaygroundHelper = {
    features: {
        0: 'Sandlåda',
        1: 'Gungor',
        2: 'Bebisgunga',
        3: 'Klätterställning',
        4: 'Rutschkana',
        5: 'Linbana',
        6: 'Lekhus',
        7: 'Kompisgunga',
        8: 'Gungbräda',
        9: 'Studsmatta',
        10: 'Plaskdamm',
        11: 'Fotbollsplan',
        12: 'Basketplan',
        13: 'Pingisbord',
        14: 'Skateramp',
        15: 'Fjädergunga',
        16: 'Balanslek',
        17: 'Cykelbana',
        249: 'Inomhus',
        250: 'Pulkabacke',
        251: 'Djur',
        252: 'Grill',
        253: 'Bänkar (för vuxna)',
        254: 'Bord',
        255: 'Tillgänglighetsanpassad'
    },

    presentPlayground: function (playground, fallbackWithId = true) {
        if (!playground) {
            return 'Ingen lekplats';
        }

        if (playground.name) {
            return playground.name;
        }

        if (fallbackWithId) {
            if (!playground._id) {
                return 'Ny lekplats';
            }

            return `Lekplats ${playground._id}`;
        }

        return 'Lekplats';
    },

    /**
     * Generates an app url for the playground for sharing purposes.
     * 
     * @param {Object} playground 
     * @returns {String} The url, or '' if no playground was specified
     */
    getPlaygroundUrl: function (playground) {
        if (!playground) {
            return '';
        }
        let url = window.location.href.split('?')[0];
        return `${url}?show=${playground._id}`;
    },

    presentFeature: function (feature) {
        if (feature in this.features) {
            return this.features[feature];
        }

        return feature;
    },

    presentRating: function (rating) {
        rating = parseFloat(rating);

        if (!rating) {
            return '';
        }

        return '&#9733'.repeat(rating.toFixed(1));
    },

    /**
     * Gets a message explaining a merge conflict, based on the error information sent back by the server.
     * 
     * @param {Object} mergeError The error object sent by the server. 
     * @returns {String} A message explaining the conflict, or false if one couldn't be generated.
     */
    presentMergeConflict: function (mergeError) {
        if (!mergeError || !mergeError.data) {
            return false;
        }

        let property = this.getTranslatedMergePropertyName(mergeError.data.conflictingKey);
        if (!property) {
            return false;
        }

        return `Det finns mer än ett värde för ${property.toLocaleLowerCase()}`;
    },

    /**
     * Gets a translated name for a playground property.
     * 
     * @param {String} property 
     * @returns {String} 
     */
    getTranslatedMergePropertyName: function(property) {
        switch (property) {
            case 'name':
                return 'Namn';

            case 'description':
                return 'Beskrivning';

            case 'food':
                return 'Mat';

            case 'toilet':
                return 'Toalett';

            case 'directions':
                return 'Ta sig hit';

            case 'parking':
                return 'Parkering';

            default:
                return property;
        }
    }
}


export default PlaygroundHelper;